import React from "react";

import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { BOOKINGSTATUS } from "../../../contants";
// import "react-big-calendar/lib/sass/styles";
const localizer = momentLocalizer(moment);

const getEventstatusColor = (event) => {
  const foundIndex = BOOKINGSTATUS.find((e) => e.key === event.bookingStatus);

  return foundIndex.bgColor;
};
const ScheduleCalendar = ({
  events: propsEvents,
  handleSelect,
  onRangeChange,
}) => {
  return (
    <Calendar
      // selectable
      localizer={localizer}
      events={propsEvents}
      scrollToTime={new Date(1970, 1, 1, 6)}
      defaultDate={new Date()}
      startAccessor="start"
      endAccessor="end"
      style={{ height: 410 }}
      defaultView={Views.DAY}
      onSelectEvent={(event) => handleSelect(event)}
      onSelectSlot={handleSelect}
      onRangeChange={(e) => onRangeChange(e)}
      formats={{
        agendaDateFormat: "DD/MM/YYYY",
        agendaHeaderFormat: ({ start, end }, culture, localizer) =>
          localizer.format(start, "DD/MM/YYYY", culture) +
          " – " +
          localizer.format(end, "DD/MM/YYYY", culture),
      }}
      eventPropGetter={(event, start, end, isSelected) => {
        let newStyle = {
          backgroundColor: getEventstatusColor(event),
        };

        return {
          style: newStyle,
        };
      }}
      components={{
        agenda: {
          time: ({ event }) => (
            <div
              onClick={() => handleSelect(event)}
            >
              {event.allDay
                ? "All day"
                : `${moment(event.start).format("h:mm a")} – ${moment(event.end).format("h:mm a")}`
              }
            </div>
          ),
        },
      }}
    />
  );
};

export default ScheduleCalendar;
